import React from 'react';
import { Card, CardContent, Typography, Avatar, Box, useTheme } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';
import { useAnalyticsSummary } from '../../hooks/useAnalyticsSummary';

const MonthlyIncomeCard: React.FC = () => {
  const theme = useTheme();
  const { data: analytics, isLoading, isError } = useAnalyticsSummary();

  let value = '—';
  if (isLoading) value = 'Loading...';
  else if (isError) value = 'Error';
  else if (analytics) value = `$${analytics.monthlyIncome?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <Card sx={{ height: '100%', backdropFilter: 'blur(20px)', backgroundColor: 'rgba(255, 255, 255, 0.9)', boxShadow: '0px 2px 24px rgba(0, 0, 0, 0.1)', borderRadius: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar 
            sx={{ bgcolor: theme.palette.success.light, color: theme.palette.success.main, mr: 2, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
          >
            <TrendingUp />
          </Avatar>
          <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
            Monthly Income
          </Typography>
        </Box>
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 600, color: theme.palette.text.primary }}>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
          This month
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MonthlyIncomeCard; 